import React, { useState, useRef, useEffect } from 'react';
import './header.css';
import headerLogo from '../assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";
import { useAuth } from '../Service/Redux/AuthContext';
import { GetProfileDetailAPI } from '../Service/API/Get';


export default function Header() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [menuActive, setMenuActive] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [userProfileData, setUserProfileData] = useState({});

  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const toggleDropdown = (event) => {
    event.preventDefault();
    setDropdownVisible(!dropdownVisible);
  };

  const userLogout = () => {
    toast.success('Logout Successfully!');
    logout();
    navigate("/login")
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const userProfileAPI = async () => {
      try {
        const response = await GetProfileDetailAPI();
        if (response && response.data) {
          setUserProfileData(response?.data?.result?.data);
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    userProfileAPI();
  }, []);

  return (
    <nav className="navbar header_outer">
      <Link to="/"><img src={headerLogo} alt="Logo" className="logo" /></Link>
      <div>
        <span className={`menu-toggle ${menuActive ? 'active-icon' : ''}`} onClick={toggleMenu}>
          {menuActive ? <RxCross1 /> : <RxHamburgerMenu />}
        </span>
        <ul className={`menu ${menuActive ? 'active' : ''}`}>
          <li><Link to="/account-details">My Account</Link></li>
          <li><Link to="/booking">Booking</Link></li>
          <li><Link to="/event">Event & Offers</Link></li>
          <li><Link to="/customer-service">Contact Us</Link></li>
          <li><Link to="/about-us">About Us</Link></li>
          <li ref={dropdownRef}>
            <Link to="" onClick={toggleDropdown}>
              {userProfileData?.profilePic ? (
                <img
                  src={userProfileData?.profilePic}
                  alt={userProfileData.userName.charAt(0).toUpperCase()}
                  className="user_icon"
                />
              ) : (
                <span className="user_icon">
                  {userProfileData?.userName?.charAt(0)?.toUpperCase()}
                </span>
              )}
              {userProfileData?.userName?.toUpperCase()} &#9662;
            </Link>

            <ul className="dropdown" style={{ display: dropdownVisible ? 'block' : 'none' }}>
              <li><Link to="/account-details">Account Details</Link></li>
              <li><Link to="/wallet">Wallet</Link></li>
              <li><Link to="/level">Level</Link></li>
              <li><Link to="/booking-history">Booking History</Link></li>
              <li><Link to="/help">Help</Link></li>
              <li><Link onClick={userLogout}>Logout</Link></li>
            </ul>
          </li>
        </ul>
      </div>
      <ToastContainer />
    </nav>
  );
}
